// extracted by mini-css-extract-plugin
export default {"conversation":"ConversationView_conversation__AjkMl","instructions":"ConversationView_instructions__EtF84","video":"ConversationView_video__p2iuY"};